import $ from 'jquery';

class StreetMapPopup {
    constructor() {
        console.log('StreetMapPopup initialized');
        this.init();
    }

    init() {
        // Find all street map images in the tab content
        const streetMapImages = document.querySelectorAll('.e-tab_img.cc-street_map, .e-tab_img.cc-floor_plan');
        
        if (streetMapImages.length === 0) return;

        // Add click handlers to each image
        streetMapImages.forEach(img => {
            // Add cursor pointer to indicate clickability
            img.style.cursor = 'pointer';
            
            // Add click handler
            img.addEventListener('click', (e) => {
                this.openPopup(e);
            });
        });

        // Add click handler to tab buttons to ensure images are clickable after tab switch
        const tabButtons = document.querySelectorAll('.c-tab_header_btn');
        tabButtons.forEach(button => {
            button.addEventListener('click', () => {
                // Reinitialize after a short delay to allow tab content to be visible
                setTimeout(() => {
                    this.init();
                }, 100);
            });
        });
    }

    openPopup(e) {
        const img = e.currentTarget;

        // Clean up any existing popup and its event listeners
        this.closePopup(true); // Pass true to indicate this is a cleanup call

        // Create popup container
        const popup = document.createElement('div');
        popup.className = 'c-street_map_popup';
        popup.innerHTML = `
            <div class="c-street_map_popup_inner">
                <div class="c-street_map_popup_content">
                    <img src="" alt="" class="c-street_map_popup_img">
                </div>
            </div>
        `;
        document.body.appendChild(popup);

        // Store the popup reference in the instance
        this.currentPopup = popup;

        // Set initial opacity for GSAP animation
        gsap.set(popup, { opacity: 0 });
        gsap.set(popup.querySelector('.c-street_map_popup_img'), { opacity: 0 });

        // Set the image source and alt text
        const popupImg = popup.querySelector('.c-street_map_popup_img');
        popupImg.src = img.src;
        popupImg.alt = img.alt;

        // Show the popup
        popup.classList.add('active');
        document.body.style.overflow = 'hidden';

        // Create timeline for animations
        const tl = gsap.timeline();

        // Fade in popup background
        tl.to(popup, {
            opacity: 1,
            duration: 0.3,
            ease: 'power2.out'
        });

        // Wait for image to load before initializing pinchzoomer
        popupImg.onload = () => {
            // Ensure image fits within viewport
            const viewportHeight = window.innerHeight * 0.9; // 90% of viewport height
            const viewportWidth = window.innerWidth * 0.9;  // 90% of viewport width
            const imageRatio = popupImg.naturalWidth / popupImg.naturalHeight;
            
            // Calculate maximum dimensions while maintaining aspect ratio
            let maxHeight, maxWidth;
            
            if (imageRatio > viewportWidth / viewportHeight) {
                // Image is wider than viewport
                maxWidth = Math.min(popupImg.naturalWidth, viewportWidth);
                maxHeight = maxWidth / imageRatio;
            } else {
                // Image is taller than viewport
                maxHeight = Math.min(popupImg.naturalHeight, viewportHeight);
                maxWidth = maxHeight * imageRatio;
            }

            // Create a container div for the image with proper dimensions
            const imageContainer = document.createElement('div');
            imageContainer.style.width = `${maxWidth}px`;
            imageContainer.style.height = `${maxHeight}px`;
            imageContainer.style.position = 'relative';
            imageContainer.style.margin = '0 auto';
            imageContainer.style.overflow = 'hidden'; // Prevent image overflow during zooming
            
            // Reset image styles to let PinchZoomer control the image
            popupImg.style.maxHeight = 'none';
            popupImg.style.maxWidth = 'none';
            popupImg.style.width = '100%';
            popupImg.style.height = '100%';
            popupImg.style.position = 'absolute';
            popupImg.style.top = '0';
            popupImg.style.left = '0';
            popupImg.style.objectFit = 'contain';
            // Set transformOrigin to center to match PinchZoomer's default setting
            popupImg.style.transformOrigin = 'center center';
            
            // Replace the current image with the container + image
            const popupContent = popup.querySelector('.c-street_map_popup_content');
            popupContent.innerHTML = '';
            imageContainer.appendChild(popupImg);
            popupContent.appendChild(imageContainer);

            // Give the image a unique ID to make it easier to reference
            const uniqueId = 'pz-map-' + Date.now();
            popupImg.id = uniqueId;
            

            // Initialize pinchzoomer with custom controls options
            $(imageContainer).pinchzoomer({
                minZoom: 1,
                maxZoom: 5,
                preserveScale: true,
                allowPinchZoom: true,
                allowMouseWheelZoom: true,
                allowDoubleTapZoom: true,
                allowDrag: true,
                allowCenterDrag: true,
                transformOrigin: 'center center',
                preloader: false,
                initZoom: 1,
                useRealZoom: true,
                zoomStep: 0.5,
                baseZoom: 1,
                scaleMode: 'proportionalInside',
                appendControls: true,
                id: uniqueId,
                adjustHolderSize: false, // Prevent PinchZoomer from changing container size
                centerImage: true, // Ensure image stays centered
                crop: true, // Keep image contained within boundaries
                handleOverDragX: true, // Improve drag behavior
                handleOverDragY: true  // Improve drag behavior
            });

            // Use timeout to allow PinchZoomer to initialize
            setTimeout(() => {
                // Find our instance by ID
                let ourInstance = PinchZoomer.get(uniqueId);
                
                if (ourInstance) {
                    
                    // Apply an immediate transform to set positioning correctly
                    if (typeof ourInstance.transform === 'function') {
                        ourInstance.transform({
                            x: 0,
                            y: 0,
                            zoom: 1
                        }, 0); // Apply immediately (0 duration)
                        
                    }
                    
                    // Check if controls() method exists
                    if (typeof ourInstance.controls === 'function') {
                        const controls = ourInstance.controls();
                        
                        if (controls && controls.controlHolder) {
                            const $controlHolder = $(controls.controlHolder);
                            
                            if ($controlHolder.length) {
                                // Hide control holder initially
                                gsap.set($controlHolder[0], { opacity: 0 });
                                
                                // Customize controls
                                this.customizeControls($controlHolder, tl, popupImg);
                            } else {
                                console.error('Control holder exists but jQuery cannot select it');
                            }
                        } else {
                            console.error('Control holder not found in controls object:', controls);
                            
                            // Fallback: try to find control holder in the DOM
                            const $fallbackControls = $('.controlHolder');
                            if ($fallbackControls.length) {
                                gsap.set($fallbackControls[0], { opacity: 0 });
                                this.customizeControls($fallbackControls, tl, popupImg);
                            }
                        }
                    } else {
                        console.error('controls() method not found on instance');
                        
                        // Fallback: try to find control holder in the DOM
                        const $fallbackControls = $('.controlHolder');
                        if ($fallbackControls.length) {
                            gsap.set($fallbackControls[0], { opacity: 0 });
                            this.customizeControls($fallbackControls, tl, popupImg);
                        }
                    }
                } else {
                    console.error('Could not find PinchZoomer instance for our image');
                    
                    // Final fallback: just try to find the control holder in the DOM
                    const $fallbackControls = $('.controlHolder');
                    if ($fallbackControls.length) {
                        gsap.set($fallbackControls[0], { opacity: 0 });
                        this.customizeControls($fallbackControls, tl, popupImg);
                    }
                }
            }, 300); // Increased timeout for more reliability
        };

        // Store the escape key handler so we can remove it later
        this.escapeHandler = (e) => {
            if (e.key === 'Escape') this.closePopup();
        };
        document.addEventListener('keydown', this.escapeHandler);

        // Store the click outside handler
        this.clickOutsideHandler = (e) => {
            if (e.target === popup) this.closePopup();
        };
        popup.addEventListener('click', this.clickOutsideHandler);
    }

    // Customize controls using jQuery and direct DOM manipulation
    customizeControls($controlHolder, tl, popupImg) {
        
        if (!$controlHolder || !$controlHolder.length) {
            console.error('Invalid control holder provided');
            return;
        }
        
        // Remove fullscreen toggle button
        $controlHolder.find('.fullscreenToggle').remove();
        
        // Update zoom in button
        const $zoomIn = $controlHolder.find('.zoomIn');
        if ($zoomIn.length) {
            $zoomIn.html(`
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#F73929" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="12" y1="5" x2="12" y2="19"></line>
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                </svg>
            `);
            $zoomIn.attr('title', 'Zoom in');
        }
        
        // Update zoom out button
        const $zoomOut = $controlHolder.find('.zoomOut');
        if ($zoomOut.length) {
            $zoomOut.html(`
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#F73929" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                </svg>
            `);
            $zoomOut.attr('title', 'Zoom out');
        }
        
        // Create and append close button
        const $closeButton = $('<button></button>')
            .addClass('c-street_map_popup_close')
            .attr('aria-label', 'Close popup')
            .html(`
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#F73929" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            `);
        
        // Store a reference to this instance to use in the click handler
        const self = this;
        
        // Use direct DOM event binding rather than jQuery's on()
        $closeButton[0].addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            self.closePopup();
        });
        
        $controlHolder.append($closeButton);
        
        // Add to timeline: fade in image and controls
        tl.to(popupImg, {
            opacity: 1,
            duration: 0.3,
            ease: 'power2.out'
        }, '-=0.1')
        .to($controlHolder[0], {
            opacity: 1,
            duration: 0.3,
            ease: 'power2.out'
        }, '-=0.2');
    }

    closePopup(isCleanup = false) {
        
        // Use the stored popup reference if available
        const popup = this.currentPopup || document.querySelector('.c-street_map_popup');
        
        if (popup) {
            const popupImg = popup.querySelector('.c-street_map_popup_img');
            const controlHolder = document.querySelector('.controlHolder');
            
            // Remove event listeners
            if (this.escapeHandler) {
                document.removeEventListener('keydown', this.escapeHandler);
                this.escapeHandler = null;
            }
            
            if (this.clickOutsideHandler) {
                popup.removeEventListener('click', this.clickOutsideHandler);
                this.clickOutsideHandler = null;
            }
            
            // Create timeline for close animation
            const tl = gsap.timeline({
                onComplete: () => {
                    // Clean up by removing any event listeners on PinchZoomer objects
                    $(PinchZoomer).off(PinchZoomer.LOAD_COMPLETE);
                    
                    // Check if we have an active instance and clean it up
                    const imgId = popupImg ? popupImg.id : null;
                    if (imgId) {
                        const instance = PinchZoomer.get(imgId);
                        if (instance) {
                            // Attempt to destroy the instance if possible
                            if (typeof instance.destroy === 'function') {
                                instance.destroy();
                            }
                        }
                    }
                    
                    // Remove the popup element
                    popup.remove();
                    document.body.style.overflow = '';
                    
                    // Clear the stored popup reference
                    this.currentPopup = null;
                }
            });

            // Only animate if this is not a cleanup call
            if (!isCleanup) {
                // Fade out controls and image first
                tl.to([controlHolder, popupImg].filter(Boolean), {
                    opacity: 0,
                    duration: 0.2,
                    ease: 'power2.in'
                })
                // Then fade out popup background
                .to(popup, {
                    opacity: 0,
                    duration: 0.3,
                    ease: 'power2.in'
                });
            } else {
                // If this is a cleanup call, just remove everything immediately
                tl.call(() => {
                    popup.remove();
                    document.body.style.overflow = '';
                    this.currentPopup = null;
                });
            }
        } else {
            console.error('No popup found to close');
        }
    }
}

export default StreetMapPopup;
